import { render, staticRenderFns } from "./diysearch.vue?vue&type=template&id=36c673fe&scoped=true&"
import script from "./diysearch.vue?vue&type=script&lang=js&"
export * from "./diysearch.vue?vue&type=script&lang=js&"
import style0 from "./diysearch.vue?vue&type=style&index=0&id=36c673fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c673fe",
  null
  
)

export default component.exports